export default __webpack_public_path__ + "static/media/minimalist-desktop.1102678e.png";